export * from './tabs'
export * from './tabs-base'
export type { TabProps } from './tabs.types'
